import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {LoginPage} from './login.page';
import {ComponentsModule} from '../../sopi/components/components.module';
import {TranslateCompiler, TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {TranslateMessageFormatCompiler} from 'ngx-translate-messageformat-compiler';
import {MultiTranslateHttpLoader} from 'ngx-translate-multi-http-loader';
import {SopiComponentsModule} from '../shared/sopi-components/sopi-components.module';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
    return new MultiTranslateHttpLoader(http, [
        {prefix: './assets/i18n/', suffix: '.json'},
        {prefix: './assets/i18n/login/', suffix: '.json'},
    ]);
}


const routes: Routes = [
    {
        path: '',
        component: LoginPage,
        data: {title: 'Login'}
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        ComponentsModule,
        // AuthModule.forRoot(),
        // LoginComponentModule,
        // AzureLoginBrowserModule,
        TranslateModule.forRoot({
            compiler: {
                provide: TranslateCompiler,
                useClass: TranslateMessageFormatCompiler
            },
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        SopiComponentsModule.forRoot(),
    ],
    declarations: [LoginPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginPageModule {
}
